import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import Form from 'react-bootstrap/Form';
import Footer from "../../Components/footer";
import Header from "../../Components/header";
import "../../assets/css/style.scss";
import productImg from "../../assets/images/product-1.png";

import { defaultProduct } from "../../Constant/index";
import { vendor } from "../../Constant/index";
import { placeOrder, createOrder } from '../../Services/Order'

import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLIC_KEY } from "../../Constant"
import { CardTravel } from "@mui/icons-material";


import { setCart } from "../../Redux/Slice/cartSlice"
import { getCart, deleteCart, addToCart } from '../../Services/Cart'


const Cartpage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { cart } = useSelector((state) => state.cart)
    const tax = useSelector((state) => state.cart.tax)

    const [carts, setCarts] = useState([]);
    const [taxPercentage, setTaxPercentage] = useState(0);
    const [total, setTotal] = useState(null);
    const [subTotal, setSubTotal] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [paymentType, setPaymentType] = useState('cod');
    const [errors, setErrors] = useState({});
    const [outOfStock, setOutOfStocks] = useState([]);
    const [outOfStockItems, setOutOfStocksItems] = useState([]);

    const [userInfo, setUserInfo] = useState({
        firstName: "",
        lastName: "",
        contact: "",
        email: "",
        address: "",
        country: "",
        city: "",
        state: "",
        zipCode: ""
    });



    useEffect(() => {
        if (tax && tax.isEnabled) {
            setTaxPercentage(tax.percentageAmount)
        }
        setCarts(cart)
    }, [cart])

    useEffect(() => {
        getBill()
    }, [carts])

    let getBill = () => {
        let total = carts.reduce((n, { cart }) => n + (cart.price * cart.quantity), 0)
        let subTotal = carts.reduce((n, { cart }) => n + (cart.price * cart.quantity), 0)
        // let discount = carts.reduce((n, { cart }) => n + (cart.discount * cart.quantity), 0)
        let discount = 0

        setTotal(total)
        setSubTotal(subTotal)
        setDiscount(discount)
    }

    let handleUserChange = (e) => {
        let { name, value } = e.target
        setUserInfo({
            ...userInfo,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: ''
        })
    }

    let handleSubmit = async () => {
        let validate = validateForm(userInfo)
        if (!validate) return

        const stripe = await loadStripe(STRIPE_PUBLIC_KEY);
        let temp = []
        carts.map(val => {
            temp.push(val.cart)
        })
        let tax = taxPercentage ? (taxPercentage / 100 * total).toFixed(2) : 0

        let payload = {
            "vendor": vendor,
            "user_info": userInfo,
            "product_name": "Grocery Products",
            "paymentMethod": paymentType == 'card' ? 'Card' : 'Cash',
            "status": "Pending",
            "cart": temp,
            "subTotal": subTotal,
            "shippingCost": 0,
            "discount": discount,
            "tax": taxPercentage ? (taxPercentage / 100 * total).toFixed(2) : 0,
            "total": total + parseFloat(tax)
        }
        if (paymentType == 'card') {
            let response = await createOrder(payload)
            if (response.status == 200) {
                localStorage.setItem("stripeSessionId", response.data.id);
                const result = stripe.redirectToCheckout({
                    sessionId: response.data.id,
                });
                if (result.error) {
                    console.log(result.error);
                }
            }
            else if (response.status == 206) {
                let temp = []
                setOutOfStocksItems(response.data.data)
                response.data.data.map(val => {
                    if (!val.inStock) {
                        temp.push(val.product)
                    }
                })
                setOutOfStocks(temp)
            }

        }
        else {
            let res = await placeOrder(payload)
            if (res.status == 200) {
                localStorage.setItem("invoiceId", res.data.data.invoiceId);
                localStorage.setItem("orderId", res.data.data.orderId);

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Order placed successfully',
                    text: "Redirecting in 2 seconds.",
                    showConfirmButton: false,
                    timer: 2000,
                    heigth: '100px'
                })
                    .then(function () {
                        navigate('/success')
                    })
            }
            else if (res.status == 206) {
                let temp = []
                setOutOfStocksItems(res.data.data)
                res.data.data.map(val => {
                    if (!val.inStock) {
                        temp.push(val.product)
                    }
                })
                setOutOfStocks(temp)
            }
        }

    }

    let validateForm = (data) => {
        let errors = {};
        let formIsValid = true;

        if (data.firstName == '') {
            formIsValid = false;
            errors["firstName"] = `First Name is required`;
        }
        if (data.lastName == '') {
            formIsValid = false;
            errors["lastName"] = `Last Name is required`;
        }
        if (data.email == '') {
            formIsValid = false;
            errors["email"] = `Email is required`;
        }
        if (data.contact == '') {
            formIsValid = false;
            errors["contact"] = `Phone no is required`;
        }
        if (data.address == '') {
            formIsValid = false;
            errors["address"] = `Address is required`;
        }
        if (data.city == '') {
            formIsValid = false;
            errors["city"] = `City is required`;
        }
        if (data.state == '') {
            formIsValid = false;
            errors["state"] = `State  is required`;
        }
        if (data.country == '') {
            formIsValid = false;
            errors["country"] = `Country is required`;
        }
        if (data.zipCode == '') {
            formIsValid = false;
            errors["zipCode"] = `Zip code is required`;
        }
        setErrors(errors);
        return formIsValid
    }

    let getCartData = async () => {
        const response = await getCart();
        dispatch(setCart(response.data))
      }

    let addCartItem = async (val) => {
        let payload = {
          vendor: vendor,
          productId: val._id,
          quantity:   1,
          cart:
          {
            "prices": val.prices,
            "image": val.image,
            "_id": val._id,
            "title": val.title,
            "description": val.description,
            "category": val.category,
            "price": val.prices.price,
            "originalPrice": val.prices.originalPrice,
            "discount": val.prices.discount,
            "quantity":  1,
            "itemTotal": val.prices.price * (val.quantity + 1)
    
          }
        }
    
        const response = await addToCart(payload);
        if (response.status == 200) {
           getCartData()
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'success',
          //   title: 'Item added to cart',
          //   showConfirmButton: false,
          //   timer: 1500,
          //   heigth: '100px'
          // })
        }
    
      }
    
      let removeCartItem =  async (val) => {
        if(val.quantity < 2) return
        let payload = {
          vendor: vendor,
          productId: val._id,
          quantity:  - 1,
          cart:
          {
            "prices": val.prices,
            "image": val.image,
            "_id": val._id,
            "title": val.title,
            "description": val.description,
            "category": val.category,
            "price": val.prices.price,
            "originalPrice": val.prices.originalPrice,
            "discount": val.prices.discount,
            "quantity":  - 1,
            "itemTotal": val.prices.price * (val.quantity - 1)
    
          }
        }
    
        const response = await addToCart(payload);
        if (response.status == 200) {
          getCartData()
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'success',
          //   title: 'Item added to cart',
          //   showConfirmButton: false,
          //   timer: 1500,
          //   heigth: '100px'
          // })
        }
      }

    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="cart-page-wapper py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-7 col-lg-8">
                                <div className="cart-formwrapper pe-4">
                                    <div className="form-mt--col mb-3">
                                        <h3 className="title-mtcart">Personal Details</h3>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">First Name</label>
                                                    <input onChange={handleUserChange} type="text" placeholder="First Name" name="firstName" value={userInfo.firstName} className="form-control control-cart-input" />
                                                    {errors.firstName ? <p className="error-msg">{errors.firstName}</p> : null}

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">Last Name</label>
                                                    <input onChange={handleUserChange} name="lastName" value={userInfo.lastName} type="text" placeholder="Last Name" className="form-control control-cart-input" />
                                                    {errors.lastName ? <p className="error-msg">{errors.lastName}</p> : null}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">Email address</label>
                                                    <input onChange={handleUserChange} name="email" value={userInfo.email} type="text" placeholder="Email address" className="form-control control-cart-input" />
                                                    {errors.email ? <p className="error-msg">{errors.email}</p> : null}

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">Phone Number</label>
                                                    <input onChange={handleUserChange} name="contact" value={userInfo.contact} type="text" placeholder="Phone Number" className="form-control control-cart-input" />
                                                    {errors.contact ? <p className="error-msg">{errors.contact}</p> : null}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-mt--col mb-3   ">
                                        <h3 className="title-mtcart">Shipping Details</h3>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">Street address</label>
                                                    <input onChange={handleUserChange} name="address" value={userInfo.address} type="text" placeholder="Street address" className="form-control control-cart-input" />
                                                    {errors.address ? <p className="error-msg">{errors.address}</p> : null}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">City</label>
                                                    <input onChange={handleUserChange} name="city" value={userInfo.city} type="text" placeholder="City" className="form-control control-cart-input" />
                                                    {errors.city ? <p className="error-msg">{errors.city}</p> : null}

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">State</label>
                                                    <input onChange={handleUserChange} name="state" value={userInfo.state} type="text" placeholder="State" className="form-control control-cart-input" />
                                                    {errors.state ? <p className="error-msg">{errors.state}</p> : null}

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">Country</label>
                                                    <input onChange={handleUserChange} name="country" value={userInfo.country} type="text" placeholder="Country" className="form-control control-cart-input" />
                                                    {errors.country ? <p className="error-msg">{errors.country}</p> : null}

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div className="form-group mb-3">
                                                    <label className="txtlable-cart">ZIP / Postal</label>
                                                    <input onChange={handleUserChange} name="zipCode" value={userInfo.zipCode} type="text" placeholder="ZIP / Postal" className="form-control control-cart-input" />
                                                    {errors.zipCode ? <p className="error-msg">{errors.zipCode}</p> : null}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-mt--col">
                                        <h3 className="title-mtcart">Select Payment Method</h3>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group mb-3">
                                                    <Form>
                                                        <div className="mb-3 d-flex flex-wrap align-items-center">

                                                            <div className="form-group payment_option_cart col-4">
                                                                <div onClick={() => setPaymentType('cod')} className={`card card-box-mtcard border-0 p-2 mb-2  ${paymentType == 'cod' ? 'active' : ''}`}>
                                                                    {/* <span className="d-inline-block me-2"><i className="fal fa-money-bill"></i></span> */}
                                                                    <Form.Check
                                                                        checked={paymentType == 'cod' ? true : false}
                                                                        inline
                                                                        label="Cash on delivery"
                                                                        name="group1"
                                                                        type="radio"
                                                                        className="item-check-radio-tag"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="payment_option_cart col-4">
                                                                <div onClick={() => setPaymentType('card')} className={`card p-2 mb-2 card-box-mtcard border-0 ${paymentType == 'card' ? 'active' : ''}`}>
                                                                    {/* <span className="d-inline-block me-2"><i className="fal fa-credit-card"></i></span> */}
                                                                    <Form.Check
                                                                        inline
                                                                        checked={paymentType == 'card' ? true : false}
                                                                        label="Card payment"
                                                                        name="group1"
                                                                        type="radio"
                                                                        className="item-check-radio-tag"
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                            <div className="col-12 col-md-5 col-lg-4">
                                <div className="cart-list--wap">
                                    <div className="cartwap--table">
                                        <ul className="head-multi-cart">
                                            <li className="cart-heading cartflex-1 text-start">Product</li>
                                            <li className="cart-heading cartflex-2 text-center">Quantity</li>
                                            <li className="cart-heading cartflex-3 text-end">Sub Total</li>
                                        </ul>
                                        <div className="cartbody--main">
                                            <ul className="cart-product-wigttag mb-0">
                                                {
                                                    carts.length ?
                                                        carts.map((val, i) => {
                                                            return (
                                                                <li className="itemcart--waptd">
                                                                    <div className="product-thumb-cart">
                                                                        <div className="img-thumb-cart">
                                                                            <img src={val.cart.image.length ? val.cart.image[0] : defaultProduct} alt="" />
                                                                        </div>
                                                                        <div className="items-infowap--prdts">
                                                                            <h5 class="prodct--mv--cart">{val.cart.title}</h5>
                                                                            <p className="price-tag-itemswg">Price: ₹{val.cart.price}</p>
                                                                            <div className="remove-txt-prdt"><button type="button" class="btn btn-remove-product">Remove</button></div>
                                                                        </div>

                                                                    </div>
                                                                    <div className="qtyflex--cart">
                                                                        <div className="cartpage--qty-wap">
                                                                            <span style={{cursor: 'pointer'}} onClick={() => removeCartItem(val.cart)} className="qty-wgt--input">-</span>
                                                                            <input type="text" value={val.cart.quantity} className="form-control control-qty-field" />
                                                                            <span style={{cursor: 'pointer'}} onClick={() => addCartItem(val.cart)} className="qty-wgt--input">+</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex-price">
                                                                        <span className="prdt-cart-price">₹{val.cart.price * val.cart.quantity}</span>
                                                                    </div>
                                                                    {
                                                                        outOfStock.includes(val.cart.title) ? <div class="error-msg-stock"><p className="error-msg">{val.cart.title} is out of stock.{outOfStockItems.filter(obj => obj.product === val.cart.title)[0].stock} available</p></div>
                                                                            : null
                                                                    }
                                                                </li>
                                                            )
                                                        })
                                                        : null
                                                }
                                            </ul>

                                        </div>
                                        <div className="total-amnt-cartpage">
                                            <div className="cupon-disc--code-value d-flex align-items-center">
                                                <div className="input-val-discnt">
                                                    <input type="text" className="form-control input-disc-code" placeholder="Enter discount code" />
                                                </div>
                                                <div className="disc-apply-button">
                                                    <button type="button" className="btn btn-apply-discnt">Apply</button>
                                                </div>
                                            </div>
                                            <ul className="cart-wigt-amnt mb-0 pt-3">
                                                <li className="amnt-total-list">
                                                    <div className="left-td-amnttxt">
                                                        <span className="items-txt-yt">SubTotal</span>
                                                    </div>
                                                    <div className="right-td-amnttxt">
                                                        <span className="mant-mt-yt">₹{(subTotal)?.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                                <li className="amnt-total-list">
                                                    <div className="left-td-amnttxt">
                                                        <span className="items-txt-yt">Discount</span>
                                                    </div>
                                                    <div className="right-td-amnttxt">
                                                        <span className="mant-mt-yt">₹{(discount)?.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                                <li className="amnt-total-list">
                                                    <div className="left-td-amnttxt">
                                                        <span className="items-txt-yt">Delivery</span>
                                                    </div>
                                                    <div className="right-td-amnttxt">
                                                        <span className="mant-mt-yt">₹0</span>
                                                    </div>
                                                </li>
                                                <li className="amnt-total-list">
                                                    <div className="left-td-amnttxt">
                                                        <span className="items-txt-yt">Tax</span>
                                                    </div>
                                                    <div className="right-td-amnttxt">
                                                        <span className="mant-mt-yt">₹{((taxPercentage / 100) * total)?.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                                <li className="amnt-total-list">
                                                    <div className="left-td-amnttxt">
                                                        <span className="items-txt-yt fw-bold">Total</span>
                                                    </div>
                                                    <div className="right-td-amnttxt">
                                                        <span className="mant-mt-yt">₹{(total + (taxPercentage / 100) * total)?.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                                <li className="proced-checkout-buton text-center mt-4">
                                                    <button onClick={handleSubmit} type="button" className="btn btn-checkout-btn" style={{ width: '100%' }}>
                                                        {
                                                            paymentType == 'card' ? 'Pay Now' : 'Order Now'
                                                        }
                                                    </button>
                                                    {
                                                        outOfStock.length ?
                                                            <p className="error-msg">Some items are out of stock</p>
                                                            : null
                                                    }
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}
export default Cartpage